import { render, staticRenderFns } from "./UserReferralCharges.vue?vue&type=template&id=46f0bba9&scoped=true&"
import script from "./UserReferralCharges.vue?vue&type=script&lang=js&"
export * from "./UserReferralCharges.vue?vue&type=script&lang=js&"
import style0 from "./UserReferralCharges.vue?vue&type=style&index=0&id=46f0bba9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f0bba9",
  null
  
)

export default component.exports